import { render, staticRenderFns } from "./privatechat.vue?vue&type=template&id=075a89df&scoped=true"
import script from "./privatechat.vue?vue&type=script&lang=js"
export * from "./privatechat.vue?vue&type=script&lang=js"
import style0 from "./privatechat.vue?vue&type=style&index=0&id=075a89df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075a89df",
  null
  
)

export default component.exports